import { BoSettingsPage } from "models/BO/BoSettingsPage"
import { makeRequest } from "./networkUtils"

export const getSettingsPages = (): Promise<BoSettingsPage[]> => {
    return makeRequest("settings/pages")
}

export const getActiveSettingsPages = (): Promise<BoSettingsPage[]> => {
    return makeRequest("settings/pages?active=true")
}

export const getBoSettingsPage = (id: string): Promise<BoSettingsPage> => {
    return makeRequest(`settings/pages/${id}`)
}

export const createBoSettingsPageDO = (boSettingsPage: BoSettingsPage): Promise<BoSettingsPage> => {
    return makeRequest("settings/pages", { method: "POST", body: boSettingsPage })
}

export const saveBoSettingsPageDO = (boSettingsPage: BoSettingsPage): Promise<BoSettingsPage> => {
    return makeRequest(`settings/pages/${boSettingsPage.id}`, { method: "PUT", body: boSettingsPage })
}

export const deleteBoSettingsPageDO = (boSettingsPage: BoSettingsPage): Promise<void> => {
    return makeRequest(`settings/pages/${boSettingsPage.id}`, { method: "DELETE" })
}

export const publishBoSettingsPageDO = (): Promise<void> => {
    return makeRequest("utils/publish", { method: "POST", body: { type: "settings/pages" } })
}